import type { StepProps } from '@/components/wizard/StepProps';

import type { BackupPolicyEditState } from './BackupPolicyCreationFlow';
import { BackupPolicySettingsPitr } from './BackupPolicySettingsPitr';
import { BackupPolicySettingsStandard } from './BackupPolicySettingsStandard';
import { isPitrPolicyType } from './backupPoliciesTypes';

export const BackupPolicySettings = (
  props: StepProps<BackupPolicyEditState>
) => {
  return isPitrPolicyType(props.wizardState.policyType) ? (
    <BackupPolicySettingsPitr {...props} />
  ) : (
    <BackupPolicySettingsStandard {...props} />
  );
};
